import { createApi } from '@reduxjs/toolkit/query/react';

import {
  SalesFunnelsEndpoints as Endpoints,
  type CheckSalesFunnelForLeadsRequest,
  type CheckSalesFunnelForLeadsResponse,
  type CreateSalesFunnelRequest,
  type CreateSalesFunnelResponse,
  type DeleteSalesFunnelRequest,
  type DeleteSalesFunnelResponse,
  type GetSalesFunnelLeadsRequest,
  type GetSalesFunnelLeadsResponse,
  type GetSalesFunnelRequest,
  type GetSalesFunnelResponse,
  type GetSalesFunnelsForFiltersRequest,
  type GetSalesFunnelsForFiltersResponse,
  type GetUserSalesFunnelsRequest,
  type GetUserSalesFunnelsResponse,
  type ListSalesFunnelsRequest,
  type ListSalesFunnelsResponse,
  type UpdateSalesFunnelRequest,
  type UpdateSalesFunnelResponse,
} from '@app/api/SalesFunnels/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { SALES_FUNNELS_CHUNK } from '@app/constants';

export const salesFunnelsApi2 = createApi({
  reducerPath: 'salesFunnelsApi2',
  baseQuery: createApiBaseQuery(SALES_FUNNELS_CHUNK),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.Get]: query<GetSalesFunnelResponse, GetSalesFunnelRequest>({
      query: ({ id, ...params }) => ({
        url: `${Endpoints.Get}/${id}`,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.ListForFilters]: query<
      GetSalesFunnelsForFiltersResponse,
      GetSalesFunnelsForFiltersRequest
    >({
      query: (params) => ({
        url: Endpoints.ListForFilters,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.List]: query<ListSalesFunnelsResponse, ListSalesFunnelsRequest>({
      query: (params) => ({
        url: Endpoints.List,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.Create]: mutation<
      CreateSalesFunnelResponse,
      CreateSalesFunnelRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.Create,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.Update]: mutation<
      UpdateSalesFunnelResponse,
      UpdateSalesFunnelRequest
    >({
      query: ({ id, data, ...params }) => ({
        url: `${Endpoints.Update}/${id}`,
        method: Methods.PUT,
        params,
        data,
      }),
    }),
    [Endpoints.Delete]: mutation<
      DeleteSalesFunnelResponse,
      DeleteSalesFunnelRequest
    >({
      query: ({ id, ...params }) => ({
        url: `${Endpoints.Delete}/${id}`,
        method: Methods.DELETE,
        params,
      }),
    }),
    [Endpoints.CheckForLeads]: query<
      CheckSalesFunnelForLeadsResponse,
      CheckSalesFunnelForLeadsRequest
    >({
      query: ({ id, ...params }) => ({
        url: `${Endpoints.CheckForLeads}/${id}`,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetUserSalesFunnels]: query<
      GetUserSalesFunnelsResponse,
      GetUserSalesFunnelsRequest
    >({
      query: (params) => ({
        url: Endpoints.GetUserSalesFunnels,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetSalesFunnelLeads]: mutation<
      GetSalesFunnelLeadsResponse,
      GetSalesFunnelLeadsRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.GetSalesFunnelLeads,
        method: Methods.POST,
        params,
        data,
      }),
    }),
  }),
});

export const {
  useGetQuery,
  useLazyGetQuery,
  useListForFiltersQuery,
  useLazyListForFiltersQuery,
  useListQuery,
  useLazyListQuery,
  useCreateMutation,
  useUpdateMutation,
  useDeleteMutation,
  useCheckForLeadsQuery,
  useLazyCheckForLeadsQuery,
  useGetUserSalesFunnelsQuery,
  useLazyGetUserSalesFunnelsQuery,
  useGetSalesFunnelLeadsMutation,
} = salesFunnelsApi2;
